import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import DataArrayIcon from "@mui/icons-material/DataArray";
import ComputerIcon from "@mui/icons-material/Computer";
import StorageIcon from "@mui/icons-material/Storage";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import SettingsSystemDaydreamIcon from "@mui/icons-material/SettingsSystemDaydream";
import CalculateIcon from "@mui/icons-material/Calculate";
import CodeIcon from "@mui/icons-material/Code";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import PercentIcon from "@mui/icons-material/Percent";

export const NavBarData = [
  {
    title: "Overall",
    icon: <HomeIcon />,
    link: "Home",
  },
  {
    title: "DSA",
    icon: <DataArrayIcon />,
    link: "Home",
  },
  {
    title: "CN",
    icon: <ComputerIcon />,
    link: "Home",
  },
  {
    title: "DBMS",
    icon: <StorageIcon />,
    link: "Home",
  },
  {
    title: "OS",
    icon: <SettingsSystemDaydreamIcon />,
    link: "Home",
  },
  {
    title: "OOPS",
    icon: <CalculateIcon />,
    link: "Home",
  },
  {
    title: "Language",
    icon: <CodeIcon />,
    link: "Home",
  },
  {
    title: "Quantitative Aptitude",
    icon: <AutoStoriesIcon />,
    link: "Home",
  },
  {
    title: "Verbal Ability",
    icon: <RecordVoiceOverIcon />,
    link: "Home",
  },
  {
    title: "Logical Reasoning",
    icon: <PercentIcon />,
    link: "Home",
  },
];
